import * as React from 'react';
import {useRoute} from 'react-router5';
import {createTask} from 'api/task/requests';
import {TaskBuilder} from 'components/TaskBuilder';
import validateResponse from '../helpers/validate-response';
import isError from '../helpers/isError';
import {toast} from 'react-toastify';
import {Helmet} from 'react-helmet';

/**
 * The create task page
 * @constructor
 */
export default function CreateTask(): React.ReactElement {
  const {router} = useRoute();

  return (
    <React.Fragment>
      <Helmet>
        <title>GrowPlace / Создать задание</title>
      </Helmet>
      <TaskBuilder
        onCreate={(values) => {
          createTask({
            title: values.title,
            description: values.description,
            preview: undefined,
            tags: values.tags,
            status: 'draft',
            items: [],
            timeLimit: {
              isActive: false,
              minutes: 0,
            },
            attemptsConfig: {
              isActive: false,
              count: 0,
            },
            gradeOptions: {
              gradeSystem: 'credit',
              creditMinimum: 0,
              count: 0,
              levels: ['0'],
            },
          }).then((response) => {
            validateResponse(response);

            if (response && !isError(response)) {
              toast.success('Задание создано');
              router.navigate('tasks');
            }
          })
        }}
      />
    </React.Fragment>
  );
}
